import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { closeForgotPasswordModal, openLoginModal } from '../../../actions/modalActions';

//Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './ForgotPassword.css';

//Intl
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

// Components
import ForgotPasswordForm from './ForgotPasswordForm/ForgotPasswordForm';

class ForgotPasswordModal extends Component {
  static propTypes = {
    closeForgotPasswordModal: PropTypes.any,
    isForgotPasswordOpen: PropTypes.bool,
    openLoginModal: PropTypes.any,
    formatMessage: PropTypes.any,
  };

  render() {
    const { closeForgotPasswordModal, openLoginModal, isForgotPasswordOpen } = this.props;
    return (
      <div>
        <Modal show={isForgotPasswordOpen} animation={false} onHide={closeForgotPasswordModal} dialogClassName={cx(s.logInModalContainer, s.forgotModal, 'forgetPasswordModal')} >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body bsClass={s.logInModalBody}>
            <div className={s.root}>
              <div className={s.forgetHead}>
                <FormattedMessage {...messages.forgotPassword} />
              </div>
              <ForgotPasswordForm openLoginModal={openLoginModal} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}


const mapState = (state) => ({
  isForgotPasswordOpen: state.modalStatus.isForgotPasswordModalOpen,
});

const mapDispatch = {
  closeForgotPasswordModal,
  openLoginModal
};

export default withStyles(s)(connect(mapState, mapDispatch)(ForgotPasswordModal));